import auth from "./modules/auth"
import config from "./modules/config"
import user from "./modules/user"

export default {
	config,
	auth,
	user
};